"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSummary = useSummary;
var RequestClearShoppingCache = _interopRequireWildcard(require("@ori-events/request-clear-shopping-cache"));
var RequestShoppingContextEvent = _interopRequireWildcard(require("@ori-events/request-shopping-context"));
var _checkoutUtils = require("@ori/checkout-utils");
var _react = require("react");
var _logger = require("../../logger");
var _TranslationKey = require("../../models/TranslationKey");
var _utils = require("../../utils");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
function useSummary({
  shoppingContext
}) {
  const {
    customerId,
    sessionId,
    shoppingBag: {
      addedItems = [],
      offers = [],
      paymentFee,
      registrationFee,
      renewalFee,
      shoppingBagItems = [],
      subscriptions = [],
      vouchers: shoppingBagVouchers = []
    } = {}
  } = shoppingContext;
  const orderItemsQuantity = (0, _utils.getOrderQuantity)({
    addedItems,
    offers,
    shoppingBagItems,
    subscriptions
  });
  const fees = [];
  if (renewalFee) {
    fees.push({
      name: _TranslationKey.TranslationKey.renewalFee,
      value: renewalFee
    });
  }
  if (registrationFee) {
    fees.push({
      name: _TranslationKey.TranslationKey.registrationFee,
      value: registrationFee
    });
  }
  if (paymentFee) {
    fees.push({
      name: _TranslationKey.TranslationKey.paymentFee,
      value: paymentFee
    });
  }
  const vouchers = shoppingBagVouchers.map(voucher => ({
    code: voucher.itemCode,
    name: voucher.itemDescription,
    value: voucher.discountAmount
  }));
  const handleRemoveVoucher = (0, _react.useCallback)(async name => {
    try {
      await (0, _utils.removeVoucher)(name);
      (0, _checkoutUtils.removeReferralInfo)(name);
      const clearCache = new CustomEvent(RequestClearShoppingCache.Name);
      window.dispatchEvent(clearCache);
      // setTimeout is set so the shopping context is requested after caches are cleared
      setTimeout(() => {
        const eventToTrigger = new CustomEvent(RequestShoppingContextEvent.Name);
        window.dispatchEvent(eventToTrigger);
      });
    } catch (error) {
      if (error instanceof Error) {
        (0, _checkoutUtils.showErrorNotification)('genericError');
        _logger.mainLogger.error(error, {
          action: 'handleRemoveVoucher'
        });
      }
    }
  }, []);
  const termsAndConditionsProps = {
    customerId
  };
  const additionalInfoProps = {
    customerId,
    sessionId: sessionId ?? ''
  };
  return {
    additionalInfoProps,
    fees,
    handleRemoveVoucher,
    orderItemsQuantity,
    termsAndConditionsProps,
    vouchers
  };
}